<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">

      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="[]">
        <template slot="prefix">
          <el-form-item v-if="viewMode === 'class'" label="日期">
            <el-date-picker v-model="filters.date" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"
              style="width: 160px"></el-date-picker>
          </el-form-item>
          <template v-else>
            <el-form-item label="开始日期">
              <el-date-picker v-model="teacherFilters.startDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择开始日期" style="width: 160px"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model="teacherFilters.endDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择结束日期" style="width: 160px"></el-date-picker>
            </el-form-item>
            <el-form-item label="教师姓名">
              <el-input v-model="teacherFilters.keyword" placeholder="请输入教师姓名" clearable
                style="width: 160px"></el-input>
            </el-form-item>
          </template>
          <el-form-item class="ms-view-toggle">
            <el-button :type="viewMode === 'class' ? 'primary' : ''" size="small" @click="switchTab('class')">按班级</el-button>
            <el-button :type="viewMode === 'teacher' ? 'primary' : ''" size="small" @click="switchTab('teacher')">按教师</el-button>
          </el-form-item>
        </template>
      </toolbar>

      <div v-show="viewMode === 'class'" class="ms-table-panel">
        <div class="tbl-scroll-host">
        <el-table :data="markingList" v-loading="markingLoading" row-key="DepartmentId"
          class="custom-tbl" style="width: 100%" height="100%">
          <el-table-column prop="Date" label="日期" width="">
            <template slot-scope="scope">{{ formatDateOnly(scope.row.Date) }}</template>
          </el-table-column>
          <el-table-column prop="DepartmentName" label="班级/部门" width=""></el-table-column>
          <el-table-column prop="TotalLessons" label="总节数" width=""></el-table-column>
          <el-table-column prop="MarkedLessons" label="已点名节数" width="">
            <template slot-scope="scope">
              <el-button type="text" @click="showSessions(scope.row)">{{ (scope.row.MarkedLessons != null) ?
                (scope.row.MarkedLessons + ' 条') : '0 条' }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="MakeupLessons" label="补点节次数" width="">
            <template slot-scope="scope">{{ (scope.row.MakeupLessons != null) ? (scope.row.MakeupLessons + ' 条') : '0 条'
            }}</template>
          </el-table-column>
          <el-table-column label="未点名" width="">
            <template slot-scope="scope">
              <el-button type="text" @click="showUnmarked(scope.row)">
                {{ (scope.row.UnmarkedLessons && scope.row.UnmarkedLessons.length) ? (scope.row.UnmarkedLessons.length +
                  '条') : '0 条' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleMarkingPageChange"
            :page-size="markingPageSize" :total="markingTotal" style="float: right">
          </el-pagination>
        </el-col>
      </div>
      <div v-show="viewMode === 'teacher'" class="ms-table-panel">
        <div class="tbl-scroll-host">
        <el-table :data="teacherMarkingList" v-loading="teacherMarkingLoading" row-key="TeacherMasterId"
          class="custom-tbl" style="width: 100%" height="100%">
          <el-table-column prop="TeacherName" label="教师" width=""></el-table-column>
          <el-table-column prop="ScheduledCount" label="应到节次" width=""></el-table-column>
          <el-table-column prop="MarkedCount" label="已点名" width=""></el-table-column>
          <el-table-column prop="UnmarkedCount" label="未点名" width=""></el-table-column>
          <el-table-column prop="MakeupCount" label="补点" width=""></el-table-column>
          <el-table-column label="点名率" width="">
            <template slot-scope="scope">{{ scope.row.MarkingRate != null ? scope.row.MarkingRate + '%' : '0%' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="showTeacherMarkingDetails(scope.row)">查看明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleTeacherMarkingPageChange"
            :page-size="teacherMarkingPageSize" :total="teacherMarkingTotal" style="float: right">
          </el-pagination>
        </el-col>
      </div>

      <!-- 未点名明细弹窗 -->
      <el-dialog
        title="未点名明细"
        :visible.sync="unmarkedDialogVisible"
        width="640px"
        top="10vh"
        custom-class="unmarked-detail-dialog"
      >
        <div v-if="unmarkedList && unmarkedList.length" class="unmarked-dialog-content">
          <el-table
            :data="pagedUnmarkedList"
            style="width:100%"
            :show-header="false"
            border
            height="320px"
            class="unmarked-table"
          >
            <el-table-column prop="ClassNo" width="90">
              <template slot-scope="scope">
                <span class="unmarked-period">第{{ scope.row.ClassNo }}节</span>
              </template>
            </el-table-column>
            <el-table-column prop="CourseName">
              <template slot-scope="scope">
                <div class="unmarked-course-name">{{ scope.row.CourseName }}</div>
                <div class="unmarked-teacher">教师：{{ scope.row.TeacherName || '未分配' }}</div>
                <div class="unmarked-time">时段：{{ scope.row.StartTime || (scope.row._startTime || '') }} - {{
                  scope.row.EndTime || (scope.row._endTime || '') }}</div>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="unmarkedList.length > 5" class="unmarked-pagination-bar">
            <el-pagination
              small
              layout="total, sizes, prev, pager, next"
              :page-sizes="[5, 10, 20]"
              :current-page.sync="unmarkedPage"
              :page-size="unmarkedPageSize"
              :total="unmarkedList.length"
              @size-change="handleUnmarkedSizeChange"
              @current-change="handleUnmarkedPageChange"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else class="unmarked-empty-tip">暂无记录</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="unmarkedDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 点名明细弹窗（显示 Sessions） -->
      <el-dialog title="点名明细" :visible.sync="sessionsDialogVisible" width="45%" top="8vh"
        custom-class="sessions-detail-dialog">
        <div v-if="sessionsList && sessionsList.length">
          <el-table :data="sessionsList" style="width:100%" max-height="460px">
            <el-table-column prop="ClassNo" label="节次" width="60" align="center"></el-table-column>
            <el-table-column prop="CourseName" label="课程" min-width="90"></el-table-column>
            <el-table-column label="时段" width="120">
              <template slot-scope="scope">{{ scope.row.StartTime || '' }} - {{ scope.row.EndTime || '' }}</template>
            </el-table-column>
            <el-table-column label="点名信息" width="180">
              <template slot-scope="scope">
                <div class="session-detail-main" :class="{ 'is-unmarked': !scope.row.IsMarked }">
                  {{ scope.row.IsMarked ? (scope.row.IsMakeup ? '已点名（补点）' : '已点名') : '未点名' }}
                </div>
                <div class="session-detail-sub">时间：{{ scope.row.LastMarkedTime || '-' }}</div>
                <div class="session-detail-sub">教师：{{ scope.row.LastMarkedByName || scope.row.LastMarkedTeacherName ||
                  scope.row.LastMarkedTeacher || scope.row.LastMarkedUser || scope.row.LastMarkedBy || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="班主任复核" width="180">
              <template slot-scope="scope">
                <div class="session-detail-main" :class="{ 'is-unreviewed': !scope.row.IsReviewed }">
                  {{ scope.row.IsReviewed ? '已复核' : '未复核' }}
                </div>
                <div class="session-detail-sub">时间：{{ scope.row.LastReviewedTime || '-' }}</div>
                <div class="session-detail-sub">教师：{{ scope.row.LastReviewedByName || scope.row.LastReviewedTeacherName ||
                  scope.row.LastReviewedTeacher || scope.row.LastReviewedUser || scope.row.LastReviewedBy || '-' }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>暂无节次数据</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="sessionsDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 教师维度点名明细弹窗 -->
      <el-dialog title="教师点名明细" :visible.sync="teacherDetailDialogVisible" width="70%" top="10vh">
        <el-table :data="teacherDetailList" v-loading="teacherDetailLoading" style="width:100%" max-height="460px">
          <el-table-column label="日期" width="120">
            <template slot-scope="scope">{{ formatDateOnly(scope.row.AttendDate) }}</template>
          </el-table-column>
          <el-table-column prop="DepartmentName" label="班级" width=""></el-table-column>
          <el-table-column label="节次" width="80">
            <template slot-scope="scope">第{{ scope.row.ClassNo }}节</template>
          </el-table-column>
          <el-table-column prop="CourseName" label="课程" width=""></el-table-column>
          <el-table-column prop="TimeRange" label="时段" width="140"></el-table-column>
          <el-table-column label="点名状态" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.IsMarked" style="color:#67C23A">
                {{ scope.row.IsMakeup ? '已点名【补点】' : '已点名' }}
              </span>
              <span v-else style="color:#F56C6C">未点名</span>
            </template>
          </el-table-column>
          <el-table-column label="点名时间" width="160">
            <template slot-scope="scope">{{ scope.row.LastMarkedTime ? formatDate(scope.row.LastMarkedTime) : '-' }}</template>
          </el-table-column>
          <el-table-column label="复核" width="80">
            <template slot-scope="scope">{{ scope.row.IsReviewed ? '已复核' : '未复核' }}</template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="teacherDetailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "@/components/DepartmentPane";
import { getMarkingStats, getMarkingStatsExport, getTeacherMarkingSummary, getTeacherMarkingDetails, getTeacherMarkingSummaryExport } from '../../api/modules/schedule-course';
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";

export default {
  components: { DepartmentPane, Toolbar },
  data() {
    const today = new Date();
    const fmt = (d) => {
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${y}-${m}-${day}`;
    };
    // 本周一
    const monday = new Date(today);
    monday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
    return {
      buttonList: [],
      viewMode: "class",
      filters: { date: fmt(today), keyword: "" },
      teacherFilters: { startDate: fmt(monday), endDate: fmt(today), keyword: "" },
      markingDepartmentId: 0,
      markingList: [],
      markingLoading: false,
      markingPage: 1,
      markingPageSize: 10,
      markingTotal: 0,
      teacherMarkingList: [],
      teacherMarkingLoading: false,
      teacherMarkingPage: 1,
      teacherMarkingPageSize: 10,
      teacherMarkingTotal: 0,
      unmarkedDialogVisible: false,
      unmarkedList: [],
      unmarkedPage: 1,
      unmarkedPageSize: 5,
      sessionsDialogVisible: false,
      sessionsList: [],
      teacherDetailDialogVisible: false,
      teacherDetailList: [],
      teacherDetailLoading: false,
      listRequestId: 0,
    };
  },
  computed: {
    /**
     * 未点名明细前端分页切片
     */
    pagedUnmarkedList() {
      if (!this.unmarkedList || !this.unmarkedList.length) return [];
      const start = (this.unmarkedPage - 1) * this.unmarkedPageSize;
      return this.unmarkedList.slice(start, start + this.unmarkedPageSize);
    },
  },
  watch: {},
  methods: {
    async exportExcel() {
      if (!this.markingDepartmentId) {
        this.$message({ message: "请先选择学校或下级节点", type: "warning" });
        return;
      }
      try {
        const isTeacherView = this.viewMode === "teacher";
        const para = isTeacherView
          ? { departmentId: this.markingDepartmentId, ...this.teacherFilters }
          : { departmentId: this.markingDepartmentId, date: this.filters.date };
        const fileName = isTeacherView ? "教师点名统计报表" : "点名统计报表";
        const response = isTeacherView
          ? await getTeacherMarkingSummaryExport(para)
          : await getMarkingStatsExport(para);
        if (!response.data) {
          this.$message({ message: "导出数据为空", type: "error" });
          return;
        }
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + ".xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("下载失败:", error);
        this.$message({ message: "导出失败", type: "error" });
      }
    },

    callFunction(item) {
      // 日期/关键字已双向绑定到 filters / teacherFilters，查询时直接使用
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },

    treeNodeClick(data) {
      const id = data && data.value ? data.value : 0;
      if (id === this.markingDepartmentId && (this.markingList.length || this.teacherMarkingList.length)) {
        return;
      }
      this.markingDepartmentId = id;
      if (this.markingDepartmentId == 0) {
        this.$message({ message: "抱歉，暂不支持总平台级别的数据统计，请选择具体的学校。", type: "error" });
        this.markingList = [];
        this.markingTotal = 0;
        this.teacherMarkingList = [];
        this.teacherMarkingTotal = 0;
        return;
      }
      this.markingPage = 1;
      this.teacherMarkingPage = 1;
      this.reloadCurrentView();
    },

    switchTab(mode) {
      if (mode === this.viewMode) return;
      this.viewMode = mode;
      if (!this.markingDepartmentId) return;
      this.markingPage = 1;
      this.teacherMarkingPage = 1;
      if (mode === "class") {
        this.loadMarkingStats({ page: 1 });
      } else {
        this.loadTeacherMarkingStats({ page: 1 });
      }
    },

    reloadCurrentView() {
      if (this.viewMode === "class") {
        this.loadMarkingStats({ page: 1 });
      } else {
        this.loadTeacherMarkingStats({ page: 1 });
      }
    },

    formatDateOnly(v) {
      if (!v) return "";
      try {
        if (typeof v === "string") return v.split(" ")[0];
        const d = new Date(v);
        const y = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        return `${y}-${m}-${day}`;
      } catch (e) { return v; }
    },

    formatDate(v) {
      if (!v) return "";
      try { return new Date(v).toLocaleString(); } catch (e) { return v; }
    },

    handleQuery() {
      this.markingPage = 1;
      this.teacherMarkingPage = 1;
      this.reloadCurrentView();
    },

    loadMarkingStats(params = {}) {
      if (!this.markingDepartmentId) return;
      const requestId = ++this.listRequestId;
      this.markingLoading = true;
      const para = Object.assign(
        {
          departmentId: this.markingDepartmentId || 0,
          date: this.filters.date,
          page: this.markingPage || 1,
          pageSize: this.markingPageSize || 10,
        },
        params
      );
      getMarkingStats(para).then((res) => {
        if (requestId !== this.listRequestId) return;
        let list = [];
        if (res && res.data && res.data.response) {
          const r = res.data.response;
          list = r.data || r || [];
          this.markingTotal = r.dataCount || (Array.isArray(list) ? list.length : 0) || 0;
          if (r.PageSize) this.markingPageSize = r.PageSize;
        }
        this.markingList = Array.isArray(list) ? list : [];
      }).catch(() => {
        if (requestId !== this.listRequestId) return;
        this.markingList = [];
        this.markingTotal = 0;
      }).finally(() => {
        if (requestId === this.listRequestId) this.markingLoading = false;
      });
    },

    loadTeacherMarkingStats(params = {}) {
      if (!this.markingDepartmentId) return;
      const requestId = ++this.listRequestId;
      this.teacherMarkingLoading = true;
      const para = Object.assign(
        {
          departmentId: this.markingDepartmentId,
          startDate: this.teacherFilters.startDate,
          endDate: this.teacherFilters.endDate,
          keyword: this.teacherFilters.keyword || "",
          page: this.teacherMarkingPage || 1,
          pageSize: this.teacherMarkingPageSize || 10,
        },
        params
      );
      getTeacherMarkingSummary(para)
        .then((res) => {
          if (requestId !== this.listRequestId) return;
          const r = res && res.data && res.data.response;
          this.teacherMarkingList = (r && r.data) ? r.data : [];
          this.teacherMarkingTotal = (r && r.dataCount) ? r.dataCount : 0;
        })
        .catch(() => {
          if (requestId !== this.listRequestId) return;
          this.teacherMarkingList = [];
          this.teacherMarkingTotal = 0;
        })
        .finally(() => {
          if (requestId === this.listRequestId) this.teacherMarkingLoading = false;
        });
    },

    handleMarkingPageChange(page) {
      if (page === this.markingPage) return;
      this.markingPage = page;
      this.loadMarkingStats({ page: this.markingPage, pageSize: this.markingPageSize });
    },

    handleTeacherMarkingPageChange(page) {
      if (page === this.teacherMarkingPage) return;
      this.teacherMarkingPage = page;
      this.loadTeacherMarkingStats({ page: this.teacherMarkingPage, pageSize: this.teacherMarkingPageSize });
    },

    /**
     * 未点名明细弹窗页码切换
     */
    handleUnmarkedPageChange(page) {
      this.unmarkedPage = page;
    },

    /**
     * 未点名明细弹窗每页条数切换
     */
    handleUnmarkedSizeChange(size) {
      this.unmarkedPageSize = size;
      this.unmarkedPage = 1;
    },

    showUnmarked(row) {
      const un = (row && row.UnmarkedLessons) ? row.UnmarkedLessons.map(u => Object.assign({}, u)) : [];
      const sessions = (row && row.Sessions) ? row.Sessions : [];
      un.forEach(item => {
        const s = sessions.find(ss => String(ss.ClassNo) === String(item.ClassNo));
        if (s) {
          item._startTime = s.StartTime || s.Start || "";
          item._endTime = s.EndTime || s.End || "";
        } else {
          item._startTime = "";
          item._endTime = "";
        }
      });
      this.unmarkedList = un;
      this.unmarkedPage = 1;
      this.unmarkedDialogVisible = true;
    },

    showSessions(row) {
      this.sessionsList = (row && row.Sessions) ? row.Sessions : [];
      this.sessionsDialogVisible = true;
    },

    showTeacherMarkingDetails(row) {
      this.teacherDetailDialogVisible = true;
      this.teacherDetailLoading = true;
      getTeacherMarkingDetails({
        teacherMasterId: row.TeacherMasterId,
        departmentId: this.markingDepartmentId,
        startDate: this.teacherFilters.startDate,
        endDate: this.teacherFilters.endDate,
      })
        .then((res) => {
          this.teacherDetailList = (res && res.data && res.data.success && Array.isArray(res.data.response))
            ? res.data.response
            : [];
        })
        .catch(() => { this.teacherDetailList = []; })
        .finally(() => { this.teacherDetailLoading = false; });
    },
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style>
/* 按班级/按教师切换：补间距（本页 style 未 scoped，勿写 /deep/）。最后修改：2026-10-20 */
.ms-view-toggle {
  margin-left: 4px !important;
}

.ms-view-toggle .el-form-item__content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ms-view-toggle .el-button + .el-button {
  margin-left: 0;
}

.ms-table-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.ms-table-panel .tbl-scroll-host {
  flex: 1;
  min-height: 0;
}

/* 未点名明细弹窗样式：固定高度，避免分页条数变化导致弹窗高低不一 */
.unmarked-detail-dialog .el-dialog__body {
  padding: 16px 20px;
  height: 404px;
  box-sizing: border-box;
  overflow: hidden;
}

.unmarked-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.unmarked-course-name {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.unmarked-period {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 54px;
  height: 28px;
  padding: 0 8px;
  border-radius: 14px;
  background: #eef4ff;
  color: #3d6fd6;
  font-size: 13px;
  font-weight: 600;
}

.unmarked-detail-dialog .unmarked-table .el-table__row > td {
  height: 88px;
  padding: 0;
}

.unmarked-detail-dialog .unmarked-table .cell {
  padding: 0 14px;
}

.unmarked-detail-dialog .unmarked-table .el-table__row:hover > td {
  background: #f5f8ff;
}

.unmarked-teacher {
  color: #606266;
  font-size: 12px;
  margin-top: 4px;
}

.unmarked-time {
  color: #909399;
  font-size: 12px;
  margin-top: 2px;
}

.unmarked-pagination-bar {
  margin-top: 12px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}

.unmarked-empty-tip {
  text-align: center;
  color: #909399;
  padding: 24px 0;
}

.sessions-detail-dialog .el-dialog__body {
  padding: 16px 22px 20px;
}

.sessions-detail-dialog .el-table .cell {
  line-height: 20px;
}

.session-detail-main {
  color: #303133;
  font-weight: 600;
}

.session-detail-main.is-unmarked,
.session-detail-main.is-unreviewed {
  color: #e6a23c;
}

.session-detail-sub {
  margin-top: 3px;
  color: #909399;
  font-size: 12px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
